import './styles.css';
import ContainerCollections from 'components/ContainerCollections';
import TemplateScreen from 'screens/TemplateScreen';

const Home = () => {
  return (
    <TemplateScreen
      Screen={(eventData, categories, subCategories, categoriesObj) => (
        <ContainerCollections
          eventData={eventData}
          categoriesObj={categoriesObj}
        />
      )}
    />
  );
};

export default Home;
